import { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Button,
  Divider,
  Drawer,
  List,
  ListItem,
  Typography,
  useTheme,
  useMediaQuery
} from '@mui/material';
import {
  BarChart as BarChartIcon,
  Users as UsersIcon,
  Archive,
  PlusSquare
} from 'react-feather';
import NavItem from '../main/NavItem';
import InputIcon from '@mui/icons-material/Input';
import CloudQueueIcon from '@mui/icons-material/CloudQueue';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import goodalipi from 'src/plugins/goodalipi';
import { services, subServices} from '../../../models/sideBar'

const DashboardSidebar = ({ onMobileClose, openMobile }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [serviceItemsState, setServiceItemsState] = useState([])
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  function displayServices(){
    let activeSubServices = goodalipi.get('user').subservices
    if(!activeSubServices){
      goodalipi.remove('user')
      goodalipi.remove('isMinor')
      sessionStorage.clear()
      navigate('/login', { replace: true });
      return
    }
    let allServices = { ...services }
    const servicesToDisplay = []
    
    Object.keys(allServices).forEach(data =>{
      allServices[data].options = []
    })
    activeSubServices.forEach(data =>{
      const key = data.split(' - ')[0]
      allServices[key].options.push(subServices[data]);
      console.log(allServices[key]);
    })
    Object.keys(allServices).forEach(data =>{
      if(allServices[data].options.length > 0){
        servicesToDisplay.push(allServices[data])
      }
    })
    setServiceItemsState(servicesToDisplay)
  }

  const loggedInUser = goodalipi.get('user')
  const isMinor = goodalipi.get('isMinor') == "isBooleantrue" ? true : false;
  const user = {
    avatar: '/static/images/' + `${(loggedInUser.gender === 'F') ? `female.png` : `male.png`}`,
    jobTitle: 'HR Manager',
    name: 'User'
  };

  if (loggedInUser) {
    user.name = loggedInUser.username
  }

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    displayServices()
  }, [location.pathname]);

  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}
    >
      {/* <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          p: 2
        }}
      >
        <Avatar
          // component={RouterLink}
          src={user.avatar}
          sx={{
            cursor: 'pointer',
            width: 64,
            height: 64
          }}
          // to="/app/account"
        />
        <Typography
          color="white"
          variant="subtitle1"
        >
          {user.name}
        </Typography>
        <Typography
          color="white"
          variant="body2"
        >
          {user.jobTitle}
        </Typography>
      </Box>
      <Divider /> */}
      <Box sx={{ p: 2 }}>
        <List>
          {serviceItemsState.map((item, key) => (
            <NavItem
              key={key}
              item={item}
            />
          ))}
        </List>
        {/* <ListItem sx={{paddingInline: '8px'}}>
          <Typography sx={{
            color: 'white',
            fontWeight: 'medium',
            cursor: 'no-drop',
          }} variant="h6">Help &amp; Support</Typography>
        </ListItem> */}
        {loggedInUser.AMEmail && 
          <ListItem sx={{paddingInline: '8px'}}>
            <Typography sx={{
              color: 'white',
              fontWeight: 'medium',
            }} variant="h6">Contact Manager</Typography>
          </ListItem>
        }
        { loggedInUser.AMEmail &&
            <Typography sx={{
              color: 'white',
              textAlign: 'start',
              fontWeight: 'normal',
              marginLeft: 1
            }} variant="subtitle2">{loggedInUser.AMEmail ? loggedInUser.AMEmail : ""}</Typography> 
        }
      </Box>
    </Box>
  );

  return (
    <>
      {!isDesktop && (
        <Drawer
          anchor="left"
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
          PaperProps={{
            sx: {
              width: 250,
              bgcolor: '#1778f2'
            }
          }}
        >
          {content}
        </Drawer>
      )}

      {isDesktop && (
        <Drawer
          anchor="left"
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: 240,
              top: 64,
              height: 'calc(100% - 95px)',
              ml: 2,
              my: 2,
              bgcolor: '#1778f2',
              borderRadius: 4
            }
          }}
        >
          {content}
        </Drawer>
      )}
    </>
  );
};

DashboardSidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

DashboardSidebar.defaultProps = {
  onMobileClose: () => { },
  openMobile: false
};

export default DashboardSidebar;
